var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4912C",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h15v15H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M2 4V3h10.001v1H2zm8.002 4H2V7h8.002v1zM7 12H2v-1h5v1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu-2.8d3983c7b8866663831eed8539a87e8f.svg";
export { ForwardRef as ReactComponent };